import type { CalendarView } from 'pages/CalendarPage/CalendarPage';

const CALENDAR_VIEW_KEY = 'calendar_view';

export const getStoredCalendarView = (): CalendarView => {
  const storedView = localStorage.getItem(CALENDAR_VIEW_KEY);
  return (storedView as CalendarView) || 'dayGridMonth';
};

export const setStoredCalendarView = (view: CalendarView): void => {
  localStorage.setItem(CALENDAR_VIEW_KEY, view);
};
